<template>
    <div class="entries font-weight-bold">
        <ResumeCard
            v-for="entry in entries"
            :key="entry.title"
            :title="entry.title"
            :icon="entry.icon"
            :color="entry.color">
            <!-- Same delay as the title, so the card's enter animation is over. -->
            <TypeReveal :delay="500">
                <div class="px-4 text-body-1 font-weight-light">
                    <div
                        v-for="detail in entry.details"
                        :key="detail.label">
                        <TypedText :text="`${detail.label} : ${detail.value}`" />
                    </div>
                    <div
                        v-for="link in entry.links"
                        :key="link.url">
                        <a
                            class="white--text text-decoration-none"
                            :href="link.url"
                            target="_blank"
                            rel="noopener">
                            <v-icon left>mdi-link</v-icon>
                            <TypedText :text="link.label" />
                        </a>
                    </div>
                </div>
                <v-card-text>
                    <span class="text-md-h5 mt-4 font-weight-bold">
                        <TypedText :text="quoted(entry.quote)" />
                    </span>
                </v-card-text>
            </TypeReveal>
        </ResumeCard>
    </div>
</template>

<script>
import TypeReveal from '@/components/effects/TypeReveal.vue';
import TypedText from '@/components/effects/TypedText.vue';
import ResumeCard from './ResumeCard.vue';

/** Education / experience cards: title, details or links, and a quote, typed in when they appear. */
export default {
    name: 'EntriesPanel',
    components: { ResumeCard, TypeReveal, TypedText },
    props: {
        entries: { type: Array, required: true },
    },
    methods: {
        quoted: (text) => `"${text}"`,
    },
};
</script>

<style scoped>
/* Long lists scroll within the section (minus the app bar), fading out at the edges. */
.entries {
    max-height: calc(100vh - 96px);
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--v-primary-darken1) transparent;
    mask-image: linear-gradient(transparent, #000 20px, #000 calc(100% - 20px), transparent);
}
</style>
